// @flow

import type {PlaceState} from '../types'

export const initialState: PlaceState = {
  place: null,
  placeList: [],
  pagination: null,
}
